import type {ICurriculum} from '../../constants'

export function curriculumGrade(item: ICurriculum): number | null {
  // Preschool is 5 in the current catalog and 99 in older clients.
  const grade = Number(item.gradeLevelId)
  if (grade === 5 || grade === 99 || /okul\s*öncesi|ana\s*(sınıf|okul)/i.test(item.title)) return 0
  if (grade >= 1 && grade <= 4) return grade
  return null
}
export function curriculumGradeLabel(item: ICurriculum): string {
  const grade = curriculumGrade(item)
  return grade === 0 ? 'Okul Öncesi' : grade ? `${grade}. Sınıf` : 'Özel kitaplık'
}
export function sortCurriculums(items: ICurriculum[]): ICurriculum[] {
  return [...items].sort(
    (a, b) =>
      (curriculumGrade(a) ?? 100) - (curriculumGrade(b) ?? 100) ||
      a.title.localeCompare(b.title, 'tr', {numeric: true}) ||
      Number(a.id) - Number(b.id)
  )
}
